<template>
  <div class="checkbox-wrapp flex flex-col gap-6">
    <input-checkbox
      v-for="checkbox in checkboxes"
      :key="checkbox.id"
      :value="checkbox.id"
      :name="name"
      :theme="theme"
      :text-in-label="true"
      :checked="value.includes(checkbox.id)"
      @input="handleChange"
    >{{ checkbox.text }}</input-checkbox>
  </div>
</template>

<script>
import inputCheckbox from './input-checkbox.vue'

export default {
  components: {
    inputCheckbox,
  },

  name: 'checkboxWrapp',

  props: {
    value: {
      type: Array,
      default: []
    },

    name: {
      type: String,
      default: '',
    },

    theme: {
      type: String,
      default: 'blue',
    },

    checkboxes: {
      type: Array,
      default: [],
    },
  },

  methods: {
    handleChange(val) {
      const index = this.value.indexOf(val)
      if (index === -1) {
        this.$emit('input', [...this.value, val])
      } else {
        this.$emit('input', [...this.value.slice(0, index), ...this.value.slice(index + 1)])
      }
    }
  }
}
</script>
